<template>
  <div class="right right-edit">
    <div class="right-header" @click="showRight = !showRight">
      <!-- <button @click="qwe()">qwe</button> -->
      <h5>Право {{ rightIndex }}</h5>
      <button class="more" :class="{'active': showRight}">
        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6 5.60876L10.4834 0.75L12 2.24761L6 8.75L-6.54624e-08 2.24761L1.51664 0.75L6 5.60876Z" fill="black" fill-opacity="0.65"/>
        </svg>
      </button>
    </div>
    <div class="right-block-wrapper" v-show="showRight">
      <div class="right-block">
        <div class="right-block-item">
          <p>Вид права</p>
          <input @click="toggleRightTypeTree(true)" class="form-control" :value="right.registration.rightTypeText" type="text">
          <!-- <p>{{ item.rightType.text}}</p> -->
        </div>
        <div class="right-block-item">
          <p>Регистрационный номер</p>
          <input class="form-control" v-model="right.registration.regNuber" type="text">
          <!-- <p>{{ item.regNumber}}</p> -->
        </div>
        <div class="right-block-item">
          <p>Дата регистрации</p>
          <input class="form-control" type="date" v-model="right.registration.regDate" max="1979-12-31">
          <!-- <p>{{ item.regDate}}</p> -->
        </div>
        <div class="right-block-item">
          <p>Доля в праве (числ)</p>
          <input class="form-control" v-model="right.registration.shareNumerator" type="number">
          <!-- <p>{{ item.shareNumerator}}</p> -->
        </div>
        <div class="right-block-item">
          <p>Доля в праве (знам)</p>
          <input class="form-control" v-model="right.registration.shareDenominator" type="number">
          <!-- <p>{{ item.shareDenominator}}</p> -->
        </div>

        <div class="right-block-item">
          <p>Сведения о правообладателях и арендаторах</p>
          <div class="owners-table-preview">
            <div class="owners-table-row">
              <span>Тип</span>
              <span>Владелец</span>
            </div>
            <div class="owners-table-row" v-for="(rightItem, index) in right.owners" :key="index">
              <span v-if="rightItem.typeOfOwner !== null && rightItem.typeOfOwner !== undefined">{{ rightItem.typeOfOwner.code_sp }}</span>
              <span v-if="rightItem.typeOfOwner !== null && rightItem.typeOfOwner !== undefined">{{ rightItem.name }}</span>
            </div>
          </div>
          <button @click="isSelectOwner = true" class="btn accent-btn select-owners-btn">Выбрать</button>
          <transition name="popup-opacity">
            <PopupVue
              v-show="isSelectOwner"
              @closePopup="closePopup()"
              class="popup-select-owner"
            >
              <template #content>
                <SelectOwnerVue @closePopup="closePopup()" @changeOwners="changeOwners($event)" :initData="rightOwnerInitData"/>
              </template>
            </PopupVue>
          </transition>
        </div>

        <div class="right-block-item">
          <p>Документы</p>
          <DocWithTypeLoader @setDocumentsWithType="setDocumentsWithType($event)" :initData="rightDocInitData" />
        </div>

        <div class="encumbrance-edit-wrap">
          <div class="right-block" v-for="(encumbrance, eindex) in right.encumbrance" :key="'right_' + rightIndex + '_encumbrance' + eindex">
            <div class="right-block-item encumbrance-item" @click="setShowEncumbrance(eindex, !encumbranceEditDetail[eindex])">
              <h6>Обременение {{ eindex + 1 }}</h6>
              <img src="@img/enc-open.svg" alt="" :class="{'active': encumbranceEditDetail[eindex]}">
              <button @click="delEncumbrance(eindex)">
                <img src="@img/close.svg" alt="">
              </button>
            </div>
            <div class="encumbrance-detail-edit-wrap" v-show="encumbranceEditDetail[eindex]">
              <EncumbranceEditVue :key="'right_' + rightIndex + '_encumbrance' + eindex + '_current'" :eindex="eindex" @closeEcumbrance="setShowEncumbrance(eindex, false)" @changeEncumbrance="changeEncumbrance($event, eindex)" :inputData="right.encumbrance[eindex].propsData" />
            </div>
          </div>
          <button @click="addEncumbrance()" class="btn btn-add">
            <span>+</span>
            Добавить обременение
          </button>
        </div>
      </div>
    </div>
    <PopupVue v-show="showRightTypeTree" @closePopup="closeTreesPopups()">
      <template #content>
        <div class="popup-tree">
          <TreeComponent v-if="showRightTypeTree" :initOnMount="true" :inputData="rightTypeOptions" :multiple="false" @setSelected="setRight($event)" />
        </div>
      </template>
    </PopupVue>
  </div>
</template>

<script>
import DocWithTypeLoader from './DocWithTypeLoader.vue'
import EncumbranceEditVue from './EncumbranceEditVue.vue'
import PopupVue from './PopupVue.vue'
import ToggleComponentVue from './ToggleComponentVue'
import TreeComponent from './tree/TreeComponent.vue'
import SelectOwnerVue from './SelectOwnerVue'
import { eventBus } from '@/main.js'

export default {
  props: ['item', 'rightIndex', 'mode', 'propsData'],
  components: {
    ToggleComponentVue,
    EncumbranceEditVue,
    TreeComponent,
    PopupVue,
    DocWithTypeLoader,
    SelectOwnerVue
  },
  data () {
    return {
      rightDocInitData: null,
      showRight: false,
      isSelectOwner: false,
      rightOwnerInitData: null,
      encumbranceEditDetail: [false],
      showRightTypeTree: false,
      right: {
        registrationNumber: null,
        registration: {
          rightTypeCode: null,
          rightTypeText: null,
          regNuber: null,
          regDate: null,
          shareNumerator: null,
          shareDenominator: null
        },
        documents: [],
        owners: [
          {
            codeSp: null,
            name: null,
            fullName: null,
            ogrn: null,
            phone: null,
            contact: {},
            address: {}
          }
        ],
        encumbrance: [
          /* {
            restrictNumber: null,
            encumbrance: {},
            documents: [],
            encumbranceOwner: []
          } */
        ]
      }
    }
  },
  computed: {
    encumbranceDetail () {
      return this.$store.getters.value('encumbranceDetail')
    },
    rightTypeOptions () {
      return this.createTreeListMix(this.$store.getters.RIGHT_LIST)
    }
  },
  created () {
    eventBus.$on('closeEncumbranceInOtherRight', this.closeEncumbranceInOtherRight)
  },
  watch: {
    right: {
      handler: function (newVal) {
        this.$emit('changeRight', newVal)
      },
      deep: true
    }
  },
  methods: {
    qwe () {
      console.log(this.propsData)
      console.log(this.right)
    },
    closePopup () {
      this.isSelectOwner = false
    },

    changeEncumbrance (e, eIndex) {
      e.propsData = this.right.encumbrance[eIndex].propsData
      this.$set(this.right.encumbrance, eIndex, e)
    },

    changeOwners (e) {
      // console.log('change owners in RIGHT', e)
      this.right.owners = e
    },

    setDocumentsWithType (e) {
      this.right.documents = e
    },

    setShowEncumbrance (index, val) {
      eventBus.$emit('closeEncumbranceInOtherRight', this.rightIndex)
      this.encumbranceEditDetail = this.encumbranceEditDetail.map(element => {
        return false
      })
      this.encumbranceEditDetail[index] = val
    },

    closeEncumbranceInOtherRight (rightIndex) {
      if (this.rightIndex === rightIndex) { // если это это же право, то ничего не делать. Иначе закрыть все обременения
        return
      }
      this.encumbranceEditDetail = this.encumbranceEditDetail.map(element => {
        return false
      })
    },

    delEncumbrance (index) {
      this.right.encumbrance.splice(index, 1)
      this.encumbranceEditDetail.splice(index, 1)
    },

    addEncumbrance () {
      this.right.encumbrance.push({
        restrictNumber: null,
        encumbrance: null,
        documents: null,
        encumbranceOwner: null
      })
      this.encumbranceEditDetail.push(false)
    },

    closeTreesPopups () {
      this.toggleRightTypeTree(false)
    },

    setRight (e) {
      this.$set(this.right.registration, 'rightTypeCode', e.fullInfo[0].id)
      this.$set(this.right.registration, 'rightTypeText', e.fullInfo[0].text)
      this.closeTreesPopups()
      // this.right.registration.rightTypeCode = e.fullInfo[0].id
      // this.right.registration.rightTypeText = e.fullInfo[0].text
    },

    toggleRightTypeTree (val) {
      if (val !== undefined) {
        this.showRightTypeTree = val
      } else {
        this.showRightTypeTree = !this.showRightTypeTree
      }
    },

    parseRight (right) {
      if (right === null || right === undefined) {
        return
      }
      if (right.rightType !== undefined && right.rightType !== null && right.rightType !== 'null') {
        this.right.registration.rightTypeCode = right.rightType.code
        this.right.registration.rightTypeText = right.rightType.text
      }
      this.right.registration.regNuber = right.regNumber
      this.right.registration.regDate = right.regDate
      this.right.registration.shareNumerator = right.shareNumerator
      this.right.registration.shareDenominator = right.shareDenominator
      if (right.rightOwnerSet !== null && right.rightOwnerSet !== 'null' && right.rightOwnerSet.edges.length > 0) {
        let owners = []
        right.rightOwnerSet.edges.forEach(rightOwnerEdge => {
          let _own = rightOwnerEdge.node.owner
          // console.log(_own)
          let _ownType = _own.sp.code
          // console.log('_ownType', _ownType)
          // console.log('_own', _own)
          if (this.isPersonMix(_ownType)) {
            owners.push({
              typeOfOwner: {
                code_sp_code: _own.sp.code,
                code_sp: _own.sp.text
              },
              oid: _own.oid,
              id: _own.pk,
              location: {
                text: null
              },
              name: _own.name,
              firstName: _own.person.firstName,
              lastName: _own.person.lastName,
              middleName: _own.person.middleName
            })
          } else if (this.isOrganizationMix(_ownType)) {
            // _own.organizationSet.edges.forEach(org => {
            //   owners.push({
            //     typeOfOwner: {
            //       code_sp_code: _own.sp.code,
            //       code_sp: _own.sp.text
            //     },
            //     oid: _own.oid,
            //     id: _own.pk,
            //     location: {
            //       text: null
            //     },
            //     name: org.node.name,
            //     fullName: org.node.fullName,
            //     ogrn: org.node.ogrn
            //   })
            // })
            owners.push({
              typeOfOwner: {
                code_sp_code: _own.sp.code,
                code_sp: _own.sp.text
              },
              oid: _own.oid,
              id: _own.pk,
              location: {
                text: null
              },
              name: _own.organization.name,
              fullName: _own.organization.fullName,
              ogrn: _own.organization.ogrn
            })
          } else {
            owners.push({
              typeOfOwner: {
                code_sp_code: _own.sp.code,
                code_sp: _own.sp.text
              },
              oid: _own.oid,
              id: _own.pk,
              location: {
                text: null
              },
              name: _own.name
            })
          }
        })
        this.rightOwnerInitData = JSON.parse(JSON.stringify(owners))
        let ownersTmp = JSON.parse(JSON.stringify(owners))
        this.right.owners = ownersTmp
      }
      this.$set(this.right, 'encumbrance', [])
      if (right.encumbranceSet !== null && right.encumbranceSet.edges.length > 0) {
        for (let i = 0; i < right.encumbranceSet.edges.length; i++) {
          let encumbranceEdge = right.encumbranceSet.edges[i]
          if (i !== 0) { // не добавлять флаг на нулевой элеменит. Он есть по умолчанию
            this.encumbranceEditDetail.push(false)
          }
          this.right.encumbrance.push({
            propsData: encumbranceEdge.node,
            restrictNumber: null,
            encumbrance: null,
            documents: null,
            encumbranceOwner: null
          })
        }
      }

      if (right.documentSet !== undefined && right.documentSet !== null && right.documentSet.edges.length > 0) {
        let rightDocArr = []
        right.documentSet.edges.forEach(rightDocEdge => {
          // console.log(rightDocEdge)
          let doc = {
            documentType: rightDocEdge.node.documentType.text,
            documentTypeCode: rightDocEdge.node.documentType.code,
            name: rightDocEdge.node.file,
            date: rightDocEdge.node.date,
            notes: rightDocEdge.node.notes,
            number: rightDocEdge.node.number,
            seria: rightDocEdge.node.seria,
            file: rightDocEdge.node.file
          }
          rightDocArr.push(doc)
        })
        this.rightDocInitData = rightDocArr
      }
    }
  },
  mounted () {
    if (this.mode === 'edit') {
      this.parseRight(this.propsData)
    }
    // console.log(this.right)
  }
}
</script>

<style lang="scss">

.right {
  h5 {
    margin-bottom: 0;
  }
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    button {
      transition: .3s;
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  &-block {
    margin-top: 15px;
    &-item {
      margin-bottom: 20px;
      h6 {
        font-size: 12px;
        font-weight: 400;
        color: #8c8c8c;
        margin-bottom: 5px;
      }
      p {
        font-size: 12px;
      }
    }
    .encumbrance-item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      margin-bottom: 0;
      border-radius: 8px;
      padding: 10px 35px 10px 15px;
      transition: .3s;
      &:hover {
        background-color: #f2f2f2;
      }
      button {
        position: absolute;
        top: 10px;
        right: 10px;
      }
      img {
        transition: .3s;
        &.active {
          transform: rotate(180deg);
        }
      }
      h6 {
        font-weight: 600;
        font-size: 14px;
        color: #242424;
        margin-bottom: 0;
      }
    }
  }
}

.right-edit {
  .form-control {
    height: 40px;
    display: block;
    width: 100%;
    font-size: 13px;
  }
}

.share-block {
  display: flex;
  .right-block-item {
    margin-right: 15px;
  }
}
.owner {
  &-block {
    &-item {
      h6 {
        font-size: 12px;
        margin-bottom: 5px;
      }
      p {
        font-size: 12px;
      }
    }
  }
}
.info-wrapper {
  margin-top: 15px;
}

.popup-tree {
  width: 100%;
  height: 100%;
  .popup {
    z-index: 2;
  }
  .popup-dialog {
    padding: 20px;
  }
}

.popup-select-owner {
  .popup-dialog {
    width: 70vw;
    height: 70vh;
  }
  .tree {
    position: absolute;
    top: 35px;
    background-color: #fff;
    max-height: 50vh;
    scrollbar-width: thin;
    box-shadow: 0px 5px 35px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    padding-left: 5px;
    z-index: 5;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #cccccc;
      border-radius: 3px;
    }
  }
}

.owners-table-preview {
  display: table;
  font-size: 12px;
  border-collapse: collapse;
  margin-bottom: 15px;
  width: 100%;
}

.owners-table-row {
  display: table-row;
  span {
    display: table-cell;
    border: 1px solid #e6e6e6;
    padding: 5px;
  }
}

.select-owners-btn {
  font-size: 12px;
  padding: 7px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/RightEditVue.vue